enum AllowedLanguageCodeEnum {
  en = 'en',
  da = 'da',
}

export default AllowedLanguageCodeEnum;
